import React from "react";

const Loader = () => {
    return (
        <div className="loadingDiv">
            <div className="loader">Loading...</div>
        </div>
    );
};

export default Loader;
